import { ScriptProps, useScript } from "../hooks/use_script";

export const AddScriptTag = (props: ScriptProps) => {
    useScript(props);
    return null;
};
